module.exports = __webpack_public_path__ + "assets/img/gift-5-25022277.png";